import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CaseView } from '../../models/caseview.model';
interface pendencyDataModel {
  value: '';
}
interface timelineDataModel {
  key: '';
}
@Component({
  selector: 'dg-timeline',
  templateUrl: './dg-timeline.component.html',
  styleUrls: ['./dg-timeline.component.scss'],
})
export class DgTimelineComponent implements OnInit, OnChanges {
  @Input() activeToggle: string;
  @Input() reqobjectTimeline: CaseView = {
    docId: 0,
    appTypeId: '',
    jobMvmntPk: '',
    jobId: 0,
    subjectId: 0,
    docNo: '',
    subject: '',
    menuId: 0,
  };
  //For Tabular Timeline
  ColumnMode = ColumnMode;
  timelineData = [] as Array<timelineDataModel>;
  //displayColumnsTimeline = [{ prop: 'name',name: 'Sr No' }, { name: 'Company' }];
  displayColumnsTimeline = [
    { prop: 'key0', name: 'Sr. No.' },
    { prop: 'key1', name: 'Officer Name' },
    { prop: 'key2', name: 'Department' },
    { prop: 'key3', name: 'Recieved Date' },
    { prop: 'key4', name: 'Sent Date' },
    { prop: 'key5', name: 'Pending Since(Days)' },
  ];
  selectedVal: string;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.getTimelineData();
  }
  createColumnObj(res: Array<pendencyDataModel>): void {
    const pendencyData = res;
    for (let i = 0; i < pendencyData.length; i++) {
      const currentResObjValue = pendencyData[i].value;
      const pendencyValueList = currentResObjValue.split('~');
      const rowObj = {} as timelineDataModel;
      const recieveDate = pendencyValueList[5];
      const sentDate = pendencyValueList[6];
      /* for (let j = 0; j < 3; j++) {
        if (j == 0) {
          rowObj['key' + j.toString()] = parseInt(pendencyValueList[j]) + 1;
        } else {
          rowObj['key' + j.toString()] = pendencyValueList[j];
        }
      } */
      rowObj['key' + String(0)] = parseInt(pendencyValueList[0]) + 1;
      rowObj['key' + String(1)] = pendencyValueList[3]
        ? pendencyValueList[3]
        : pendencyValueList[1];
      rowObj['key' + String(2)] = pendencyValueList[4]
        ? pendencyValueList[4]
        : pendencyValueList[2];
      rowObj['key' + String(3)] = recieveDate ? recieveDate : 'N/A';
      rowObj['key' + String(4)] = sentDate ? sentDate : 'N/A';
      //  const days = this.calcDays(recieveDate, sentDate);
      const days = sentDate
        ? this.calcDays(recieveDate, sentDate)
        : this.calcDays(recieveDate, pendencyValueList[9]);
      rowObj['key' + String(5)] =
        days > 1 ? String(days) + ' ' + 'days' : String(days) + ' ' + 'day';
      this.timelineData.push(rowObj);
    }
    this.timelineData = [...this.timelineData];
    console.log('FinalData', this.timelineData);
  }
  calcDays(rec: string, send: string): number {
    // To set two dates to two variables
    const date1 = new Date(rec);
    const date2 = new Date(send);

    // To calculate the time difference of two dates
    const Difference_In_Time = date2.getTime() - date1.getTime();

    // To calculate the no. of days between two dates
    const Difference_In_Days = Math.round(
      Difference_In_Time / (1000 * 3600 * 24)
    );
    console.log('days', Difference_In_Days);
    return Difference_In_Days;
  }
  ngOnChanges(changes: SimpleChanges): void {
    /*  if ((changes.attachId && (changes.attachId.currentValue !== changes.attachId.previousValue)) && this.edit && this.attachId) {
       this.getAllAttachment();
     } */
    console.log(changes);
  }
  getTimelineData(): void {
    //static
    /*  const timelineDataTemp = [
      {
        "key": "DATA",
        "value": "1~Tappal   (Tappal, Law)~Law~AK BALAN  (Minister, Law)~Law~29-Oct-2020 11:02:41~29-Oct-2020 11:02:41~8880~0 day~02-Dec-2020 16:43:32~0~0~3015128~3014938~8881",
        "category": "PD"
      }
    ];
   this.createColumnObj(timelineDataTemp); */
    //static End

    //API call
    console.log('case details in timeline', this.reqobjectTimeline);
    const params = new HttpParams()
      .set('mvmntPk', this.reqobjectTimeline.jobMvmntPk)
      .set('caseId', this.reqobjectTimeline.docId.toString())
      .set('appTypeId', this.reqobjectTimeline.appTypeId)
      .set('dbSchema', '-1');
    /* .set("langId",this.reqobjectTimeline.row.jobMvmntPk)
   .set("locId", this.reqobjectTimeline.row.jobMvmntPk); */
    const url = '/case-mgmnt/case-pendency-details';

    this.http.get(url, { params }).subscribe(
      (response: { data: [] }) => {
        const tempRes = response.data;
        this.createColumnObj(tempRes);
      },
      (err) => {
        console.log('Api hit failure', err);
      }
    );
  }
}
